/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Cost,
    CostFromJSON,
    CostFromJSONTyped,
    CostToJSON,
} from './';

/**
 * 
 * @export
 * @interface CloudBucketCosts
 */
export interface CloudBucketCosts {
    /**
     * 
     * @type {Cost}
     * @memberof CloudBucketCosts
     */
    storage: Cost;
    /**
     * 
     * @type {Cost}
     * @memberof CloudBucketCosts
     */
    transferIn: Cost;
    /**
     * 
     * @type {Cost}
     * @memberof CloudBucketCosts
     */
    transferOut: Cost;
}

export function CloudBucketCostsFromJSON(json: any): CloudBucketCosts {
    return CloudBucketCostsFromJSONTyped(json, false);
}

export function CloudBucketCostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudBucketCosts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storage': CostFromJSON(json['storage']),
        'transferIn': CostFromJSON(json['transfer_in']),
        'transferOut': CostFromJSON(json['transfer_out']),
    };
}

export function CloudBucketCostsToJSON(value?: CloudBucketCosts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'storage': CostToJSON(value.storage),
        'transfer_in': CostToJSON(value.transferIn),
        'transfer_out': CostToJSON(value.transferOut),
    };
}


